module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['record-item', {
      'selected': _vm.selected,
      'lmr-design': _vm.isLmrConsumer
    }]
  }, [_c('div', {
    staticClass: "record-header"
  }, [_c('div', {
    staticClass: "record-tags"
  }, [_c('m-l-tags', {
    attrs: {
      "record": _vm.record
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_vm._l((_vm.processStatusesSorted), function(proc) {
    return (_vm.record.mldata.approved) ? _c('div', {
      key: proc.process + proc.status
    }, [(proc.process === 'intro' && ['done', 'error'].includes(proc.status)) ? _c('span', {
      staticClass: "download-action glyphicon glyphicon-download-alt clickable",
      class: {
        highlight: _vm.record.mldata.notes
      },
      attrs: {
        "title": _vm.$t('records.download')
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.downloadRecord(_vm.record)
        }
      }
    }) : _vm._e(), _vm._v(" "), (proc.process === 'intro' && proc.status === 'waiting') ? _c('span', {
      staticClass: "download-waiting-action glyphicon glyphicon-download-alt waving",
      attrs: {
        "title": _vm.$t('process_status.download_waiting')
      }
    }) : _vm._e(), _vm._v(" "), (proc.process === 'intro' && proc.status === 'running') ? _c('span', {
      staticClass: "download-waiting-action glyphicon glyphicon-download-alt waving",
      attrs: {
        "title": _vm.$t('process_status.download_waiting')
      }
    }) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.record.mldata.approved && !_vm.getProcessList.includes('intro') && !_vm.getProcessList.includes('cut')) ? _c('div', [_c('span', {
    staticClass: "download-action glyphicon glyphicon-download-alt clickable",
    class: {
      highlight: _vm.record.mldata.notes
    },
    attrs: {
      "title": _vm.$t('records.download')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.downloadRecord(_vm.record)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.record.mldata.approved) ? _c('div', {
    staticClass: "notes"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-edit clickable",
    class: {
      highlight: _vm.record.mldata.notes
    },
    attrs: {
      "title": _vm.$t('records.edit_comment')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.editRecordNotes(_vm.record)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.record.mldata.approved && !_vm.record.ghost) ? _c('div', {
    staticClass: "download-action"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-download-alt clickable",
    class: {
      highlight: _vm.record.mldata.notes
    },
    attrs: {
      "title": _vm.$t('records.download')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.downloadRecord(_vm.record)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.record.ghost) ? _c('div', {
    staticClass: "download-waiting-action"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-download-alt waving",
    class: {
      highlight: _vm.record.mldata.notes
    },
    attrs: {
      "title": _vm.$t('process_status.download_waiting')
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.hideDeleteIcon) ? _c('div', {
    staticClass: "delete-record",
    attrs: {
      "title": ""
    }
  }, [(_vm.record.mldata.deleted_at) ? _c('span', {
    staticClass: "glyphicon clickable glyphicon-repeat",
    attrs: {
      "title": _vm.$t('records.restore')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.restoreRecord()
      }
    }
  }) : (_vm.record.record_type == 'VIDEO') ? _c('span', {
    staticClass: "glyphicon clickable glyphicon-trash",
    attrs: {
      "title": _vm.$t('records.delete')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.deleteRecord()
      }
    }
  }) : (_vm.record.record_type == 'IMAGE') ? _c('span', {
    staticClass: "glyphicon clickable glyphicon-trash",
    attrs: {
      "title": _vm.$t('records.delete_image')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.deleteRecord()
      }
    }
  }) : _vm._e()]) : _vm._e()], 2), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "process-checkmarks"
  }, [_vm._l((_vm.processStatusesSorted), function(proc) {
    return _c('span', {
      key: proc.process + proc.status,
      staticClass: "process-status",
      attrs: {
        "title": _vm.$t(("process_status." + (proc.process) + "_" + (proc.status)))
      }
    }, [(proc.process === 'cut' && proc.status === 'running') ? _c('img', {
      staticClass: "waving",
      attrs: {
        "src": require("@/assets/img/scissors-icon-black.svg"),
        "alt": "Trimming"
      }
    }) : _vm._e(), _vm._v(" "), (proc.process === 'cut' && proc.status === 'done') ? _c('img', {
      attrs: {
        "src": require("@/assets/img/scissors-icon-checked.svg"),
        "alt": "Trimming done"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.$route.path !== '/videos') ? [(proc.process === 'intro' && proc.status === 'waiting') ? _c('img', {
      attrs: {
        "src": require("@/assets/img/gramophone-icon-gray.svg"),
        "alt": "Process"
      }
    }) : _vm._e(), _vm._v(" "), (proc.process === 'intro' && proc.status === 'running') ? _c('img', {
      staticClass: "waving",
      attrs: {
        "src": require("@/assets/img/gramophone-icon-black.svg"),
        "alt": "Processing"
      }
    }) : _vm._e(), _vm._v(" "), (proc.process === 'intro' && proc.status === 'done') ? _c('img', {
      attrs: {
        "src": require("@/assets/img/gramophone-icon-checked.svg"),
        "alt": "Processed"
      }
    }) : _vm._e()] : _vm._e(), _vm._v(" "), (proc.process === 'ftpupload' && proc.status === 'waiting') ? _c('v-icon', {
      staticClass: "waiting-link"
    }, [_vm._v("link")]) : _vm._e(), _vm._v(" "), (proc.process === 'ftpupload' && (
      proc.status === 'running' || (proc.status === 'done' && !_vm.record.digiteka_id)
    )) ? _c('v-icon', {
      staticClass: "waving-45"
    }, [_vm._v("link")]) : _vm._e()], 2)
  }), _vm._v(" "), (_vm.digitekaLink) ? _c('v-btn', {
    staticClass: "dg-link",
    attrs: {
      "fab": "",
      "small": "",
      "flat": "",
      "title": _vm.$t('digiteka_copy_link_title'),
      "href": _vm.digitekaLink,
      "target": "_blank"
    }
  }, [_c('v-icon', [_vm._v("link")])], 1) : _vm._e()], 2)], 1), _vm._v(" "), _c('div', {
    class: ['inner-record', 'center-block', {
      'clickable': _vm.isChoosingMode
    }],
    style: ([_vm.record.consumer == 'lng_sdk' ? {
      'background-color': '#eef5f9'
    } : {}]),
    on: {
      "click": function($event) {
        return _vm.clickedRecordCardHandler(_vm.record)
      }
    }
  }, [(!_vm.record.ghost) ? _c('thumbnail', {
    staticClass: "thumbnail clickable center-block",
    attrs: {
      "media": _vm.record.media,
      "default": _vm.record.thumbnail_link
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.clickedRecordHandler(_vm.record)
      }
    }
  }) : _c('div', {
    staticClass: "thumbnail ghost center-block"
  }, [_c('div', {
    staticClass: "loading-indicator"
  }), _vm._v(" "), _c('p', [_vm._v("Processing...")])]), _vm._v(" "), (_vm.isLmrConsumer) ? _c('div', [_c('div', {
    staticClass: "lmr-user-cat"
  }, [_c('div', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.record.lmr_category))]), _vm._v(" "), (!_vm.record.mldata.approved && !_vm.record.mldata.deleted_at) ? _c('v-select', {
    staticClass: "record_group",
    attrs: {
      "disabled": _vm.isChoosingMode,
      "items": _vm.record.available_groups.map(function (data) { return ({
        value: data.id,
        text: data.localized_name[0].translation
      }); }),
      "label": "Edition",
      "value": _vm.record.groups[0].id,
      "dense": "",
      "outlined": "",
      "solo": "",
      "flat": "",
      "hide-details": "",
      "color": "red",
      "background-color": "#dcdbdb"
    },
    on: {
      "input": function($event) {
        return _vm.changeEdition(_vm.record.id, _vm.selected_group)
      }
    },
    model: {
      value: (_vm.selected_group),
      callback: function($$v) {
        _vm.selected_group = $$v
      },
      expression: "selected_group"
    }
  }) : (_vm.record.groups.length > 0 && _vm.record.mldata.approved && !_vm.record.mldata.deleted_at) ? _c('div', {
    staticClass: "edition"
  }, [_vm._v(_vm._s(_vm.record.groups[0].group_name))]) : (_vm.record.groups.length > 0 && !_vm.record.mldata.approved && _vm.record.mldata.deleted_at) ? _c('div', {
    staticClass: "edition"
  }, [_vm._v(_vm._s(_vm.record.groups[0].group_name))]) : _c('div')], 1), _vm._v(" "), (!_vm.record.title && _vm.record.comment && _vm.record.consumer != 'lavoix') ? _c('p', {
    staticClass: "comment"
  }, [_vm._v("\n          " + _vm._s(_vm.record.comment) + "\n        ")]) : _c('p', {
    staticClass: "comment"
  }, [_vm._v("\n          " + _vm._s(_vm.record.title) + "\n        ")]), _vm._v(" "), _c('p', [_c('small', [_vm._v(_vm._s(_vm.$t('records.recorded')) + "\n            "), _c('time-ago', {
    attrs: {
      "value": _vm.record.shooting_date
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('records.ago'))
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('records.by'))
    }
  }), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.record.user_full_name))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'tel:' + _vm.record.contact_phone
    }
  }, [_c('br'), _vm._v(_vm._s(_vm.record.contact_phone))])], 1)])]) : _c('p', [_c('small', [_vm._v(_vm._s(_vm.$t('records.recorded')) + "\n          "), _c('time-ago', {
    staticClass: "highlight",
    attrs: {
      "value": _vm.record.shooting_date
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('records.ago'))
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('records.by'))
    }
  }), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.record.user))])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "highlight"
  }, [(_vm.record.mldata.relevance) ? _c('span', [_vm._v(" Relevance: " + _vm._s(_vm.record.mldata.relevance))]) : _vm._e(), _vm._v(" "), (_vm.record.mldata.consistency) ? _c('span', [_vm._v(" Consistency: " + _vm._s(_vm.record.mldata.consistency))]) : _vm._e(), _vm._v(" "), (_vm.record.mldata.diversity) ? _c('span', [_vm._v(" Diversity: " + _vm._s(_vm.record.mldata.diversity))]) : _vm._e()]), _vm._v(" "), (_vm.selected) ? [(_vm.showSelectIndex) ? _c('div', {
    staticClass: "record-selected-marker",
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.selectIndex) + "\n        ")]) : _c('v-icon', {
    staticClass: "record-selected-marker",
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("\n          check_circle\n        ")])] : _vm._e(), _vm._v(" "), (_vm.record.merged) ? _c('div', {
    staticClass: "merged-icon",
    attrs: {
      "title": "This record was produced by merge of other records"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/animation-play.svg"),
      "alt": "merged"
    }
  })]) : _vm._e()], 2), _vm._v(" "), _c('input', {
    ref: "copyText",
    staticClass: "copy-text",
    attrs: {
      "type": "text"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ca8433a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marker/record/RecordItem.vue
// module id = 1041
// module chunks = 1